export default "__VITE_ASSET__BzSHigFD__"